import { Flex, Grid, Heading, Img, Link, Stack, Text } from '@chakra-ui/react'
import * as React from 'react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { getAge } from '../utils'
import ProfileImage from '../assets/profil.jpeg'
import FadeInUpBox from '../components/fade-in-up-box'

function About() {
  return (
    <Grid minH="100vh" p={3}>
      <Stack
        justifyContent="space-around"
        alignSelf="center"
        direction={['column', 'column', 'column', 'row']}
        p={[4, 6, 10, 15, 40]}
      >
        <Flex basis="auto" shrink={0} justifyContent="center" alignItems="center">
          <FadeInUpBox yOffset={64} duration={1}>
            <Img
              borderRadius="full"
              boxSize={['100px', '200px', '300px', '300px']}
              src={ProfileImage}
              alt="Julien Le Pêcheur"
              className="object-cover w-full"
            />
          </FadeInUpBox>
        </Flex>
        <Flex className="max-w-screen-md" direction="column" justifyContent="center" p={[0, 0, 0, 10]}>
          <FadeInUpBox yOffset={64} duration={1}>
            <Heading className="mb-4" as="h2" size="3xl">
              About
            </Heading>
          </FadeInUpBox>
          <FadeInUpBox yOffset={64} duration={1} delayOrder={2}>
            <Text fontSize="lg" className="text-justify">
              I&apos;m Julien, a {getAge('1998-10-19')}-year-old fullstack developer based in France, currently
              freelancing for{' '}
              <Link color="teal.500" isExternal href="https://weabea.io/">
                Weabea <ExternalLinkIcon mx="2px" />
              </Link>{' '}
              — building SaaS tools for payroll and portage companies.
            </Text>
            <br />
            <Text fontSize="lg" className="text-justify">
              I work across the stack: <strong>React (Remix)</strong> on the frontend, <strong>FastAPI</strong> on the
              backend, <strong>PostgreSQL</strong>, and <strong>AWS</strong> infrastructure with{' '}
              <strong>Terraform</strong>. I also integrate services like Stripe, Twilio, Supabase, and Brevo.
            </Text>
            <br />
            <Text fontSize="lg" className="text-justify">
              On personal projects I lean toward <strong>Next.js + NestJS + PostgreSQL</strong>.
            </Text>
            <br />
            <Text fontSize="lg" className="text-justify">
              Open to full-remote freelance opportunities. — hire me on{' '}
              <Link color="teal.500" isExternal href="https://www.malt.fr/profile/julienlepecheur">
                Malt <ExternalLinkIcon mx="2px" />
              </Link>
            </Text>
          </FadeInUpBox>
        </Flex>
      </Stack>
    </Grid>
  )
}

export default About
